<template>
  <b-card>
    <div style="position: relative">
      <loading-overlay :loading="loading" />
      <b-tabs v-model="activeTab">
        <template #tabs-end>
          <li class="ml-auto d-flex justify-content-end">
            <loader-btn
              @click="saveMethod"
              :loading="working"
              variant="success"
            />
          </li>
        </template>
        <!-- <b-tab title="سيريتل كاش">
          <b-row class="align-items-center mt-1">
            <b-col cols="4">
              <alert
                massage="يجب أن يكون رقم الموبايل المدخل يملك حساب تبرع إلكتروني لدى شركة <strong>سيريتل</strong> . <br>  في حال وجود أي استفسار الرجاء التواصل مع الوزارة."
                color="warning"
                class="w-100"
              />
            </b-col>
            <b-col>
              <form-cleave
                label="رقم الهاتف"
                isNumber
                :charsCount="10"
                v-model="syriatel.phone_number"
              />
            </b-col>
            <b-col class="mx-1">
              <b-form-checkbox
                v-model="syriatel.active"
                class="custom-control-success"
                >فعال</b-form-checkbox
              >
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="MTN Cash">
          <b-row class="align-items-center mt-1">
            <b-col cols="4">
              <alert
                massage="يجب أن يكون رقم الموبايل المدخل يملك حساب تبرع إلكتروني لدى شركة <strong>MTN</strong> . <br>  في حال وجود أي استفسار الرجاء التواصل مع الوزارة."
                color="warning"
                class="w-100"
              />
            </b-col>
            <b-col>
              <form-cleave
                label="رقم الهاتف"
                isNumber
                :charsCount="10"
                v-model="mtn.phone_number"
              />
            </b-col>
            <b-col>
              <form-cleave
                label="رقم بوابة التبرع"
                isNumber
                :charsCount="16"
                v-model="mtn.mtn_terminal_number"
              />
            </b-col>
            <b-col>
              <form-cleave
                label="كود التغعيل"
                isNumber
                :charsCount="8"
                v-model="mtn.mtn_activation_code"
              />
            </b-col>
            <b-col class="mx-1">
              <b-form-checkbox
                v-model="mtn.active"
                class="custom-control-success"
                >فعال</b-form-checkbox
              >
            </b-col>
          </b-row>
        </b-tab> -->
        <b-tab title="فاتورة">
          <b-row class="align-items-center mt-1">
            <b-col>
              <form-input label="اسم المستخدم" v-model="fatora.username" />
            </b-col>
            <b-col>
              <form-cleave
                label="رقم بوابة التبرع"
                isNumber
                :charsCount="10"
                v-model="fatora.terminal_id"
              />
            </b-col>
            <b-col>
              <form-input
                label="كلمة السر"
                type="password"
                v-model="fatora.password"
              />
            </b-col>
            <b-col class="mx-1">
              <b-form-checkbox
                v-model="fatora.active"
                class="custom-control-success"
                >فعال</b-form-checkbox
              >
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
      <data-table
        bordered
        class="my-2"
        id="transactions-table"
        :fields="transactionsFields"
        ref="transactionsTable"
        :ep="transactionsTableEp"
        @row-clicked="viewTransaction"
        hover
      >
        <template #cell(amount)="{ value }">
          {{ new Intl.NumberFormat().format(parseInt(value)) }}
        </template>
        <template #cell(created_at)="{ value }">
          {{ $moment(value).format("YYYY-MM-DD") }}
        </template>
        <template #cell(status_name)="{ value }">
          <span
            class="alert px-50"
            :class="
              value.includes('بانتظار') ? 'alert-warning' : 'alert-success'
            "
            >{{ value }}</span
          >
        </template>
      </data-table>
      <b-sidebar
        right
        width="500px"
        shadow
        bg-variant="white"
        backdrop
        id="transaction-view"
        v-model="transactionViewVisible"
      >
        <div class="p-1">
          <h3>معلومات العملية</h3>
          <hr />
          <info-card
            label="رقم العملية"
            :value="activeTransaction.transaction_uuid"
          />
          <info-card
            label="رقم صاحب عملية التحويل"
            :value="activeTransaction.customer_number"
          />
          <info-card
            label="المبلغ"
            :value="
              new Intl.NumberFormat().format(parseInt(activeTransaction.amount))
            "
          />
          <info-card
            label="تاريخ العملية"
            :value="$moment(activeTransaction.created_at).format('YYYY-MM-DD')"
          />
          <info-card
            label="حالة العملية"
            :value="activeTransaction.status_name"
          />
        </div>
      </b-sidebar>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BButton,
  BTabs,
  BFormCheckbox,
  BFormRow,
  BCol,
  BTab,
  BSidebar,
} from "bootstrap-vue";
import FormCleave from "@/components/FormCleave.vue";
import FormInput from "@/components/form-input";
import LoaderBtn from "@/components/loader-btn.vue";
import Alert from "@/components/Alert.vue";
import { mapGetters, mapActions } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import DataTable from "@/components/data-table";
import InfoCard from "@/components/InfoCard.vue";
export default {
  components: {
    BCard,
    BRow,
    BButton,
    BTabs,
    BFormCheckbox,
    BFormRow,
    BCol,
    BTab,
    BSidebar,
    FormCleave,
    LoaderBtn,
    Alert,
    DataTable,
    LoadingOverlay,
    InfoCard,
    FormInput,
  },
  data() {
    return {
      transactionViewVisible: false,
      activeTransaction: {},
      transactionsFields: [
        { key: "transaction_uuid", label: "رقم العملية" },
        { key: "created_at", label: "تاريخ العملية" },
        { key: "amount", label: "المبلغ" },
        { key: "customer_number", label: "رقم صاحب عملية التحويل" },
        { key: "status_name", label: "حالة العملية" },
      ],
      activeTab: 0,
      fatora: {
        payment_method_type_id: 3,
        active: false,
      },
      // syriatel: {
      //   payment_method_type_id: 2,
      //   active: false,
      // },
      // mtn: {
      //   payment_method_type_id: 1,
      //   active: false,
      // },
    };
  },

  watch: {
    activeTab: {
      handler(val) {
        // if (val === 0) {
        //   var data = this.methods.find(
        //     (el) => el.paymentMethodType.name === "SYRIATEL"
        //   );
        //   if (data) {
        //     this.syriatel.phone_number = data.username_or_phone_number.toString().slice(-10).replace(data.username_or_phone_number.toString().slice(-10)[0], "0");
        //     this.syriatel.active = data.active;
        //     this.syriatel.payment_method_type_id = data.paymentMethodType.id;
        //     this.syriatel.id = data.id;
        //   }
        // } else if (val === 1) {
        //   var data = this.methods.find(
        //     (el) => el.paymentMethodType.name === "MTN"
        //   );
        //   if (data) {
        //     this.mtn.phone_number = data.username_or_phone_number.toString().slice(-10).replace(data.username_or_phone_number.toString().slice(-10)[0], "0");
        //     this.mtn.mtn_activation_code = data.mtn_activation_code;
        //     this.mtn.mtn_terminal_number = data.mtn_terminal_number;
        //     this.mtn.active = data.active;
        //     this.mtn.payment_method_type_id = data.paymentMethodType.id;
        //     this.mtn.id = data.id;
        //   }
        // } else {
          var data = this.methods.find(
            (el) => el.paymentMethodType.name === "FATORA"
          );
          if (data) {
            this.fatora.username = data.username_or_phone_number;
            this.fatora.password = data.password;
            this.fatora.terminal_id = data.terminal_id;
            this.fatora.active = data.active;
            this.fatora.payment_method_type_id = data.paymentMethodType.id;
            this.fatora.id = data.id;
          }
        // }
        // else {
        //   var data = this.methods.find((el)=> el.paymentMethodType.name === 'SYRIATEL')
        //   this.syriatel.phone_number = data.phone_number
        //   this.syriatel.active = data.active

        // }
      },
    },
  },
  computed: {
    ...mapGetters("manageInterfaceNgo/PaymentMethods", [
      "methods",
      "loading",
      "working",
    ]),
    transactionsTableEp() {
      // return this.activeTab === 0
      //   ? "v2/transactions?meType=SYRIATEL"
      //   : this.activeTab === 1
      //   ? "v2/transactions?meType=MTN"
      //   : "v2/transactions?meType=FATORA";
      return "v2/transactions?meType=FATORA";
    },
  },

  methods: {
    ...mapActions("manageInterfaceNgo/PaymentMethods", [
      "getMethods",
      "createMethod",
      "updateMethod",
    ]),
    saveMethod() {
      // if (this.activeTab === 0) {
      //   if (this.syriatel.id) this.updateMethod(this.syriatel);
      //   else this.createMethod(this.syriatel);
      // } else if (this.activeTab === 1) {
      //   if (this.mtn.id) this.updateMethod(this.mtn);
      //   else this.createMethod(this.mtn);
      // } else {
        if (this.fatora.id) this.updateMethod(this.fatora);
        else this.createMethod(this.fatora);
      // }
    },
    viewTransaction(trans) {
      this.activeTransaction = trans;
      this.transactionViewVisible = true;
    },
  },

  created() {
    this.getMethods().then(() => {
      // var syriatelData = this.methods.find(
      //   (el) => el.paymentMethodType.name === "SYRIATEL"
      // );
      // if (syriatelData) {
      //   this.syriatel.phone_number = syriatelData.username_or_phone_number.toString().slice(-10).replace(syriatelData.username_or_phone_number.toString().slice(-10)[0], "0");
      //   this.syriatel.active = syriatelData.active;
      //   this.syriatel.payment_method_type_id =
      //     syriatelData.paymentMethodType.id;
      //   this.syriatel.id = syriatelData.id;
      // }
      // var mtnData = this.methods.find(
      //   (el) => el.paymentMethodType.name === "MTN"
      // );
      // if (mtnData) {
      //   this.mtn.phone_number = mtnData.username_or_phone_number.toString().slice(-10).replace(mtnData.username_or_phone_number.toString().slice(-10)[0], "0");
      //   this.mtn.mtn_activation_code = data.mtn_activation_code;
      //   this.mtn.mtn_terminal_number = data.mtn_terminal_number;
      //   this.mtn.active = mtnData.active;
      //   this.mtn.payment_method_type_id = mtnData.paymentMethodType.id;
      //   this.mtn.id = mtnData.id;
      // }
      var fatoraData = this.methods.find(
        (el) => el.paymentMethodType.name === "FATORA"
      );
      if (fatoraData) {
        this.fatora.username = fatoraData.username_or_phone_number;
        this.fatora.password = fatoraData.password;
        this.fatora.terminal_id = fatoraData.terminal_id;
        this.fatora.active = fatoraData.active;
        this.fatora.payment_method_type_id = fatoraData.paymentMethodType.id;
        this.fatora.id = fatoraData.id;
      }
    });
  },
};
</script>
